export const reasonCodes = {
  easy_to_understand: 'Easy to understand',
  accurate: 'Accurate information',
  useful: 'Useful for me',
  inspiring: 'Inspiring',
  hard_to_understand: 'Hard to understand',
  inaccurate: 'Inaccurate information',
  not_useful: 'Not useful',
  wanted_deeper_guidance: 'Wanted deeper guidance',
}

export default reasonCodes
